// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-role-modal__text.baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-top: 18px;
    margin-bottom: 24px;
}

.profile-role-modal__content {
    margin: 0 85px;
}

.profile-role-modal__container .modal2__container {
    width: 30%;
}

.select-field.profile-role-modal__role-selector__select-input {
    margin: 0;
    /* border: 1px solid var(--new-gray-background-color);
    border-radius: 9px; */
}

.profile-role-modal__role-selector__select-input .select-field-input {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 9px;
    background-color: var(--white-color);
}

.profile-role-modal__role-selector__title {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    position: relative;
}

.profile-role-modal__role-selector__title .baloa-username {
    color: var(--primary-dark-color);
    margin-right: 6px;
    font-weight: var(--font-medium);
}

.profile-role-modal__role-selector__title .hubicon-help_fill::before {
    color: var(--new-green-color);
    opacity: 0.64;
    cursor: pointer;
}

.profile-role-modal__role-selector__title__tooltip.baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
}

.profile-role-modal__actions.form__actions {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid var(--new-input-background-color);
    margin-top: 18px;
}

.profile-role-modal__role-selector__select-input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before {
    border: none !important;
}
.profile-role-modal__role-selector__select-input .MuiInput-underline.select-field-input:before {
    border: none;
    transition: none;
}
.profile-role-modal__role-selector__select-input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused {
    border-style: none !important;
}

.profile-role-modal__role-selector__select-input .MuiListItemText-multiline .MuiListItemText-secondary {
    display: none;
}

.profile-role-modal__role-selector__select-input .MuiSelect-select:focus {
    background-color: unset;
}

.profile-role-modal__profile-profession-type .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root{
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 9px;
}

.profile-role-modal__profile-profession-type .MuiFormLabel-root{
    color: var(--primary-dark-color);
    font-weight: var(--font-medium);
    font-size: var(--space);
    text-transform: inherit;
}

.profile-role-modal__profile-profession-type{
    margin-top: 30px;
}

.profile-role-modal__profile-profession-type.MuiAutocomplete-listbox{
    padding: 8px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-role-modal__container .modal2__container {
        width: 100%;
    }   

    .profile-role-modal__content {
        margin: 0 24px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-role-modal/ProfileRoleModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT;yBACqB;AACzB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,uDAAuD;IACvD,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".profile-role-modal__text.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-top: 18px;\n    margin-bottom: 24px;\n}\n\n.profile-role-modal__content {\n    margin: 0 85px;\n}\n\n.profile-role-modal__container .modal2__container {\n    width: 30%;\n}\n\n.select-field.profile-role-modal__role-selector__select-input {\n    margin: 0;\n    /* border: 1px solid var(--new-gray-background-color);\n    border-radius: 9px; */\n}\n\n.profile-role-modal__role-selector__select-input .select-field-input {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 9px;\n    background-color: var(--white-color);\n}\n\n.profile-role-modal__role-selector__title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 4px;\n    position: relative;\n}\n\n.profile-role-modal__role-selector__title .baloa-username {\n    color: var(--primary-dark-color);\n    margin-right: 6px;\n    font-weight: var(--font-medium);\n}\n\n.profile-role-modal__role-selector__title .hubicon-help_fill::before {\n    color: var(--new-green-color);\n    opacity: 0.64;\n    cursor: pointer;\n}\n\n.profile-role-modal__role-selector__title__tooltip.baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n}\n\n.profile-role-modal__actions.form__actions {\n    display: flex;\n    justify-content: flex-end;\n    border-top: 1px solid var(--new-input-background-color);\n    margin-top: 18px;\n}\n\n.profile-role-modal__role-selector__select-input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before {\n    border: none !important;\n}\n.profile-role-modal__role-selector__select-input .MuiInput-underline.select-field-input:before {\n    border: none;\n    transition: none;\n}\n.profile-role-modal__role-selector__select-input .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused {\n    border-style: none !important;\n}\n\n.profile-role-modal__role-selector__select-input .MuiListItemText-multiline .MuiListItemText-secondary {\n    display: none;\n}\n\n.profile-role-modal__role-selector__select-input .MuiSelect-select:focus {\n    background-color: unset;\n}\n\n.profile-role-modal__profile-profession-type .search_members_staff_edit_content .input-field-autocomplete .MuiInputBase-root{\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 9px;\n}\n\n.profile-role-modal__profile-profession-type .MuiFormLabel-root{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-medium);\n    font-size: var(--space);\n    text-transform: inherit;\n}\n\n.profile-role-modal__profile-profession-type{\n    margin-top: 30px;\n}\n\n.profile-role-modal__profile-profession-type.MuiAutocomplete-listbox{\n    padding: 8px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-role-modal__container .modal2__container {\n        width: 100%;\n    }   \n\n    .profile-role-modal__content {\n        margin: 0 24px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
